import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { Button } from '@/components/common';
import { ROUTES } from '@/utils/constants';

export const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-dark flex items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-white mb-2">الصفحة غير موجودة</h2>
        <p className="text-gray-400 mb-8">عذراً، الصفحة التي تبحث عنها غير موجودة</p>
        <Link to={ROUTES.SEARCH}>
          <Button variant="primary" className="gap-2">
            <Home className="h-5 w-5" />
            العودة للرئيسية
          </Button>
        </Link>
      </div>
    </div>
  );
};